<template>
  <div :class="['input-block-buttons', showDelete && showAdd ? 'two-button-show' : null]">
    <img v-if="showDelete && ((lastIndex !== 0 && lastIndex !== -1) || isComponent)" src="@/assets/img/cancel.svg"
      class="input-block-button-delete" alt="delete" @click="$emit('delete')">
    <img v-if="lastIndex === 0 && lastIndex !== -1 && !isComponent" src="@/assets/img/cancel.svg"
      class="input-block-button-delete" alt="clear" @click="$emit('clear')">
    <img v-if="showAdd && (lastIndex !== -1 || isComponent)" src="@/assets/icons/add-arrow.svg"
      class="input-block-button-add" alt="add" @click="$emit('add')">
    <img v-if="lastIndex === -1 && !isComponent" src="@/assets/icons/add-arrow.svg" class="input-block-button-add"
      alt="add" @click="$emit('setDefault')">
  </div>
</template>
<script>
export default {
  name: 'AddRemoveButton',
  props: {
    showAdd: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    lastIndex: {
      type: Number,
      default: null
    },
    isComponent: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clear', 'delete', 'add', 'setDefault']
}
</script>
<style lang="scss">
.two-button-show {
  width: 13% !important;
  justify-content: space-between !important;
}

.input-block-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 7%;

  .input-block-button-add {
    width: 1.4rem;
    height: 1.4rem;
  }

  .input-block-button-delete {
    width: 1rem;
    height: 1rem;
  }
}
</style>
